"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regist_1 = require("../../redux/regist");
const actionType_1 = require("./actionType");
const initialState = {
    depths: 'home',
    menu: { menu: 'home', detail: 'list' },
    id: '',
    props: {},
    name: '',
};
regist_1.ReducerRegistry.register('base/menu', (state = initialState, action) => {
    switch (action.type) {
        case actionType_1.SET_MENU:
            return {
                ...state,
                depths: action.depths,
                menu: action.menu,
                id: action.id,
                props: action.props,
            };
        case actionType_1.CHANGE_MENU_PROPS:
            return {
                ...state,
                props: action.props,
            };
        case actionType_1.CHANGE_MOBIL_MENU_NAME:
            return {
                ...state,
                name: action.name,
            };
    }
    return state;
});
